<template>
  <div class="br-modal">
    <div class="br-modal__dialog">
      <div class="br-modal__head">
        <span class="br-modal__title">Your Plus Plan Estimate</span>
        <button
          v-modal
          class="button button--icon js-close-modal">
          <i class="icon icon-e-remove"/>
        </button>
      </div>
      <div class="br-modal__body">
        <div class="notice">
          <div class="notice__icon">
            <i class="icon icon-question"/>
          </div>
          <div class="notice__content">
            <p><strong>This Estimate</strong>: We will estimate your setup and monthly cost based on the options you choose below. Any applicable taxes are not included, and your fees are subject to increase with additional purchases. </p>
          </div>
        </div>
        <div class="br-pricing-estimate">
          <div class="br-pricing-estimate__panel">
            <div class="br-pricing-estimate__panel__head">
              <h2>Organization Type</h2>
            </div>
            <div class="br-pricing-estimate__panel__body">
              <div class="form-group">
                <label
                  for=""
                  class="label">Which option best encompasses your orginization?</label>
                <div class="select u-border-radius">
                  <select
                    id=""
                    name="">
                    <option>Non-Profit</option>
                    <option>Others</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="br-pricing-estimate__panel">
            <div class="br-pricing-estimate__panel__head">
              <h2>Community Size</h2>
            </div>
            <div class="br-pricing-estimate__panel__body">
              <p>It looks like you are looking to invite about <strong class="u-color-a">5,000</strong> people to your networking community?</p>
              <slider
                v-model="model.community_size"
                type="size"
                :min="5000"
                :max="50000"/>
            </div>
          </div>
          <div class="br-pricing-estimate__panel">
            <div class="br-pricing-estimate__panel__head">
              <h2>Additional Services</h2>
              <button class="button button--circle">
                <i class="icon icon-i-delete"/>
              </button>
            </div>
            <div class="br-pricing-estimate__panel__body">
              <div class="checkbox-list">
                <div class="checkbox u-border-radius">
                  <input
                    id="cb1"
                    type="checkbox"
                    class="checkbox__input">
                  <label
                    for="cb1"
                    class="checkbox__label">
                    <h3>Full Community Management </h3>
                    <p>Are you and your team too busy to manage your orginization’s networking community? Let us do it for you.</p>
                    <span>$350.00 per month</span>
                  </label>
                </div>
                <div class="checkbox u-border-radius">
                  <input
                    id="cb2"
                    type="checkbox"
                    class="checkbox__input">
                  <label
                    for="cb2"
                    class="checkbox__label">
                    <h3>Custom Software Integrations</h3>
                    <p>Do you need to create a custom data integration? We can work with you or your 3rd party software provider to make it work!</p>
                    <span>$2,500.00 (one-time fee)</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="br-pricing-estimate__panel">
            <div class="br-pricing-estimate__panel__head br-pricing-estimate__panel__head--break">
              <h2>Cost Breakdown</h2>
              <div class="br-pricing-estimate__currency">
                <button class="button button--circle button--active">
                  <i class="icon icon-currency-dollar"/>
                </button>
                <button class="button button--circle">
                  <i class="icon icon-currency-yen"/>
                </button>
                <button class="button button--circle">
                  <i class="icon icon-currency-euro"/>
                </button>
                <button class="button button--circle">
                  <i class="icon icon-currency-pound"/>
                </button>
              </div>
            </div>
            <div class="br-pricing-estimate__panel__body">
              <div class="br-pricing-estimate__summary">
                <div class="br-pricing-estimate__summary__item">
                  <span class="text u-color-green"><i class="icon icon-c-check"/></span>
                  <span class="text">Non-Profit Organization </span>
                  <div class="text-group-vertical">
                    <span class="text text--highlight">Discount Applied </span>
                    <span class="text text--muted">(monthly savings)</span>
                  </div>
                </div>
                <div class="br-pricing-estimate__summary__item">
                  <span class="text u-color-green"><i class="icon icon-c-check"/></span>
                  <span class="text">A.I. Networking Community (5,000 invitees)</span>
                  <div class="text-group-vertical">
                    <span class="text text--highlight">$1,150/mo </span>
                    <span class="text text--muted">(billed monthly)</span>
                  </div>
                </div>
                <div class="br-pricing-estimate__summary__item br-pricing-estimate__summary__item--alt">
                  <span class="text">Cost to Get Started:</span>
                  <div class="text-group-vertical">
                    <span class="text text--highlight">$1,400</span>
                    <span class="text text--muted">(one-time cost)</span>
                  </div>
                </div>
                <div class="br-pricing-estimate__summary__item br-pricing-estimate__summary__item--alt">
                  <span class="text">Monthly Cost:</span>
                  <div class="text-group-vertical">
                    <span class="text text--highlight">$1,150</span>
                    <span class="text text--muted">(billed monthly)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="button button--block u-border-radius">
            Talk to Sales
          </button>
        </div>
      </div>
      <!-- <div class="br-modal__foot">
        <button class="button button--block u-border-radius">
          Talk to Sales
        </button>
      </div> -->
    </div>
  </div>
</template>

<script>
import Slider from '../components/Slider'

export default {
  components: {
    Slider
  },
  data: () => ({
    model: {
      community_size: 50000
    }
  })
}
</script>
